import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  SetUserInfo: "[Set User Info] Action",
  SetToken: "[Set Token] Action",
  SetFCMToken: "[Set FCM Token] Action"
};

const initialAuthState = {
  user: undefined,
  authId: undefined,
  authToken: undefined,
  phoneFourChar: undefined
};

export const reducer = persistReducer(
  { storage, key: "v0.0.1-schoolapp-auth", whitelist: ["user", "token"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { user, authToken } = action.payload;
        return { ...state, user, authToken };
      }

      case actionTypes.Logout: {
        const { returnPathname } = action.payload;
        const { user, authId, authToken, phoneFourChar } = initialAuthState;
        return { ...state, user, authId, authToken, phoneFourChar, returnPathname };
      }

      case actionTypes.SetUserInfo: {
        const { authId, phoneFourChar } = action.payload;
        return { ...state, authId, phoneFourChar };
      }

      case actionTypes.SetToken: {
        const { authToken } = action.payload;
        return { ...state, authToken };
      }

      case actionTypes.SetFCMToken: {
        const { token } = action.payload;
        return { ...state, token };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (user, authToken) => ({ type: actionTypes.Login, payload: { user, authToken } }),
  logout: (returnPathname) => ({ type: actionTypes.Logout, payload: { returnPathname } }),
  setUserInfo: (authId, phoneFourChar) => ({ type: actionTypes.SetUserInfo, payload: { authId, phoneFourChar } }),
  setToken: (authToken) => ({ type: actionTypes.SetToken, payload: { authToken } }),
  setFCMToken: (token) => ({ type: actionTypes.SetFCMToken, payload: { token } })
};